import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-synagoge',
  templateUrl: './synagoge.component.html',
  styleUrls: ['./../app.component.css']
})
export class SynagogeComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
